const pageSetting = (() => {
  try {
    return JSON.parse(storageGet('page_setting') || '{}');
  } catch (e) {
    return {};
  }
})();

function storageSet(key: string, value: any) {
  return localStorage.setItem(key, value);
}

function storageGet(key: string) {
  return localStorage.getItem(key);
}

function storageRemove(key: string) {
  return localStorage.removeItem(key);
}

function getPageSetting() {
  return pageSetting;
}

function changePageSetting(key: string, value: any) {
  pageSetting[key] = value;
}

function savePageSetting() {
  storageSet('page_setting', JSON.stringify(pageSetting));
}

export {
  storageSet,
  storageGet,
  storageRemove,
  savePageSetting,
  changePageSetting,
  getPageSetting,
};
